import {PushNotifications} from "@capacitor/push-notifications";
import {AdobePushNotificationsPlugin} from "@app/core/notifications/infrastructure/adobe-push-notifications-plugin";
import {ActionPerformed} from "@app/core/notifications/infrastructure/dtos/action-performed";
import {Injectable} from "@angular/core";
import {PushNotificationsService} from "@app/core/notifications/infrastructure/interfaces/push-notifications.service";
import {DeepLink} from "@app/core/shared/domain/entities/deep-link";
import {Observable, Subject} from "rxjs";
import {DeepLinkMapper} from "@app/core/shared/infrastructure/mappers/deep-link.mapper";
import {environment} from "src/environments/environment";
import {EnvironmentPlatform} from "src/environments/environment-template";

@Injectable()
export class NativePushNotificationsService implements PushNotificationsService {

    constructor() {
        this.listenPushNotificationAction();
    }

    private readonly mapper = new DeepLinkMapper();

    private readonly receivedDeepLinkSubject = new Subject<DeepLink>();
    private readonly receivedDeepLink$ = this.receivedDeepLinkSubject.asObservable();

    getDeepLink(): Observable<DeepLink> {
        return this.receivedDeepLink$;
    }

    private listenPushNotificationAction() {
        if (environment.PLATFORM === EnvironmentPlatform.WEB) {
            return;
        }
        PushNotifications.addListener('pushNotificationActionPerformed', event => {
            this.handlePushNotificationAction(event);
        });
        AdobePushNotificationsPlugin.addListener('pushNotificationActionPerformed', event => {
            this.handlePushNotificationAction(event);
        });
    }

    /**
     * Called when an action is performed on a push notification.
     * @param notification
     * @private
     */
    private handlePushNotificationAction(notification: ActionPerformed) {
        const deepLink = this.mapPushNotificationActionToDeepLink(notification);
        if (deepLink === null) {
            return;
        }
        this.receivedDeepLinkSubject.next(deepLink);
    }

    private mapPushNotificationActionToDeepLink(notification: ActionPerformed): DeepLink | null {
        const uri = notification.notification.data.uri;
        return this.mapper.mapPathWithQueryParamsToDeepLink(uri);
    }
}
